export const REQUIRED_MSG = '필수 정보입니다.';
